import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toHandlers as _toHandlers, mergeProps as _mergeProps, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "gt-auth-form gt-auth-form--width_xl" }
const _hoisted_2 = { class: "gt-auth-form__logo-wrapper gt-space_mb gt-space_mb--4 gt-space_mb--7-xl" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "gt-auth-form__logo",
  src: "/static/app/gt-auth-logo.svg",
  alt: "tt-logo-image"
}
const _hoisted_5 = { class: "gt-auth-form__title gt-space_mb gt-space_mb--4" }
const _hoisted_6 = { class: "ds-caption ds-caption--size_lg ds-caption--bold ds-caption--appearance_center" }
const _hoisted_7 = { class: "gt-auth-form__description gt-space_mb gt-space_mb--7" }
const _hoisted_8 = { class: "ds-caption ds-caption--size_sm ds-caption--appearance_center" }
const _hoisted_9 = { class: "error-label error-label--styled" }
const _hoisted_10 = { class: "global-error" }
const _hoisted_11 = { class: "gt-auth-form__wrapper" }
const _hoisted_12 = { class: "g-row g-row--appearance_spaced g-row--space_xl g-row--justify_center" }
const _hoisted_13 = { class: "g-cell g-cols g-cols--12 g-cols--6-md" }
const _hoisted_14 = { class: "g-row g-row--appearance_spaced g-row--space_xl g-row--align_center g-row--justify_center" }
const _hoisted_15 = { class: "g-cell g-cols g-cols--12" }
const _hoisted_16 = { class: "g-cell g-cols g-cols--12" }
const _hoisted_17 = { class: "g-cell g-cols g-cols--12" }
const _hoisted_18 = { class: "g-cell g-cols g-cols--12 g-cols--6-md" }
const _hoisted_19 = { class: "g-row g-row--appearance_spaced g-row--space_xl g-row--align_center g-row--justify_center" }
const _hoisted_20 = { class: "g-cell g-cols g-cols--12" }
const _hoisted_21 = { class: "g-cell g-cols g-cols--12" }
const _hoisted_22 = { class: "gt-button__title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_VeeError = _resolveComponent("VeeError")!
  const _component_d_control_input = _resolveComponent("d-control-input")!
  const _component_VeeForm = _resolveComponent("VeeForm")!
  const _directive_mask = _resolveDirective("mask")!

  return (_openBlock(), _createBlock(_component_VeeForm, { onSubmit: $setup.request }, {
    default: _withCtx(({ errors, resetForm }) => [
      _createElementVNode("div", _hoisted_1, [
        ($setup.load)
          ? (_openBlock(), _createBlock(_component_loader, { key: 0 }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          ($setup.logo_main)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "gt-auth-form__logo",
                src: $setup.logo_main,
                alt: "tt-logo-image"
              }, null, 8, _hoisted_3))
            : (_openBlock(), _createElementBlock("img", _hoisted_4))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, _toDisplayString($setup.$t('Account deletion')), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("p", _hoisted_8, _toDisplayString($setup.$t('If you want to delete your account, please fill out the form below and we will contact you to confirm your request.')), 1)
        ]),
        _createVNode(_component_VeeError, { name: "nonFieldErrors" }, {
          default: _withCtx(({ message }) => [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(message), 1)
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _withDirectives(_createVNode(_component_d_control_input, {
                    rules: "required|max:255|phoneMinLength:19",
                    name: "phone",
                    type: "phone",
                    "input-label": $setup.$t('Phone'),
                    modelValue: $setup.phone,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.phone) = $event))
                  }, null, 8, ["input-label", "modelValue"]), [
                    [_directive_mask, $setup.phoneMask]
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_d_control_input, {
                    rules: "required",
                    name: "password",
                    type: "password",
                    "input-label": $setup.$t('Password'),
                    modelValue: $setup.password,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.password) = $event))
                  }, null, 8, ["input-label", "modelValue"])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_d_control_input, {
                    rules: "required|max:255",
                    name: "fullName",
                    type: "text",
                    "input-label": $setup.$t('Full name'),
                    modelValue: $setup.fullName,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.fullName) = $event))
                  }, null, 8, ["input-label", "modelValue"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_d_control_input, _mergeProps({
                    "input-label": $setup.textField.label,
                    modelValue: $setup.reason,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.reason) = $event)),
                    placeholder: $setup.textField.placeholder || '',
                    disabled: $setup.textField.disabled
                  }, _toHandlers($setup.textField?.events ? $setup.textField.events : {}), $setup.textField), null, 16, ["input-label", "modelValue", "placeholder", "disabled"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("button", {
                class: _normalizeClass(["gt-button", {'disabled': !$setup.phone || !$setup.password || !$setup.fullName || !$setup.reason}]),
                type: "submit"
              }, [
                _createElementVNode("p", _hoisted_22, _toDisplayString($setup.$t('Send')), 1)
              ], 2)
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}